import axios from "../axios";

import { useAuthStore } from "../stores/auth";

export const calculateKnit = async (
  entityGauge,
  dimension,
  patternEntityCount,
  patternAdditionalCount
) => {
  const authStore = useAuthStore();
  const authToken = authStore.authToken;

  const params = {
    entity_gauge: entityGauge,
    dimension: dimension,
    pattern_entity_count: patternEntityCount,
    pattern_additional_count: patternAdditionalCount,
  };

  const response = await axios.get("/tools/knitcalculator", {
    params: params,
    headers: { Authorization: `Bearer ${authToken}` },
  });

  return [
    new ResultProperties(
      response.data.lower_entity_count,
      response.data.lower_dimension,
      response.data.lower_pattern_repetition,
      patternAdditionalCount
    ),
    new ResultProperties(
      response.data.higher_entity_count,
      response.data.higher_dimension,
      response.data.higher_pattern_repetition,
      patternAdditionalCount
    ),
  ];
};

const mapButtonholeSuggestion = (suggestion) => {
  return {
    buttonCount: suggestion.button_count,
    edgeStitchCount: suggestion.edge_stitch_count,
    intervalStitchCount: suggestion.interval_stitch_count,
    stitchCount: suggestion.stitch_count,
  };
};

export const calculateButtonholes = async (
  initialStitchCount,
  ribPatternRepetition,
  minButtonCount,
  maxButtonCount
) => {
  const authStore = useAuthStore();
  const authToken = authStore.authToken;

  const params = {
    initial_stitch_count: initialStitchCount,
    rib_pattern_repetition: ribPatternRepetition,
    min_button_count: minButtonCount,
    max_button_count: maxButtonCount,
  };

  const response = await axios.get("/tools/buttonholecalculator", {
    params: params,
    headers: { Authorization: `Bearer ${authToken}` },
  });

  return {
    initialStitchCount: response.data.initial_stitch_count,
    ribPatternRepetition: response.data.rib_pattern_repetition,
    minButtonCount: response.data.min_button_count,
    maxButtonCount: response.data.max_button_count,
    suggestions: response.data.suggestions.map(mapButtonholeSuggestion),
  };
};

export class ResultProperties {
  constructor(count, dimension = null, patternRepetition = null, patternAdditionalCount = null) {
    this.count = count;
    this.dimension = dimension;
    this.patternRepetition = patternRepetition;
    this.patternAdditionalCount = patternAdditionalCount;
  }
}
